var _adjustHeader = function() {
    var $header = $('.site-header'), $window = $(window);
    $header.toggleClass('bg-black', $window.scrollTop() > $header.outerHeight());
};

$().ready(function(){
    $(window).on('scroll', _adjustHeader);
    $(window).on('resize', _adjustHeader);
    $(window).on('load', _adjustHeader);
});
